export const settlementAdjustment = {
  title: "Complete booking data",
  close: "Close",
  loading: "Loading…",
  intro: "For bookings imported without a breakdown or old ones: fill in what the channel didn't send. Anything left blank is calculated as usual. It doesn't change the guest invoice, only the owner settlement.",
  price: "Booking price",
  guestCleaning: "Cleaning included in the price",
  guestCleaningHint: "What the guest paid for cleaning within the price. Now: {now}.",
  otaCommission: "Real OTA commission (excl. VAT)",
  otaCommissionHint: "Now: {now}.",
  otaCommissionHintEstimated: "Now estimated with the listing %: {now}. Enter what the channel charged.",
  managerCleaning: "Cleaning you keep on this booking",
  managerCleaningHint: "Replaces the listing's fixed amount for this booking only. Now: {now}.",
  note: "Note",
  notePlaceholder: "E.g. old booking, cleaning at €40",
  reset: "Back to automatic",
  cancel: "Cancel",
  save: "Save",
  saving: "Saving…",
  saved: "Booking completed: the settlement has been recalculated.",
  loadError: "Couldn't load the booking data.",
  saveError: "Couldn't save.",
  invalid: "Check the amounts: they must be positive numbers.",
};
